module.exports = __webpack_public_path__ + "static/qb-contact-f2730188266c36364392a41852deb9b1.jpg";